
import { useEffect, useState } from "react";
import { Form, Lead } from "@/types";
import { Achievement, getInitialAchievements, getAdvancedAchievements } from "@/data/achievement-definitions";

export type { Achievement };

export function useAchievementBadges(forms: Form[], leads: Lead[]) {
  const [achievements, setAchievements] = useState<Achievement[]>([]);
  const [earnedCount, setEarnedCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [initialBadgesCompleted, setInitialBadgesCompleted] = useState(false);

  useEffect(() => {
    // Get achievements from definitions
    const initialAchievements = getInitialAchievements(forms, leads);
    const advancedAchievements = getAdvancedAchievements(forms, leads);
    
    // Check if all initial achievements are earned
    const allInitialAchievementsEarned = initialAchievements.every(achievement => achievement.earned);
    setInitialBadgesCompleted(allInitialAchievementsEarned);

    // Combine all achievements
    const allAchievements = [...initialAchievements, ...advancedAchievements];
    setAchievements(allAchievements);
    
    // Calculate earned count
    const earned = allAchievements.filter(a => a.earned).length;
    setEarnedCount(earned);
    setTotalCount(allAchievements.length);
  }, [forms, leads]);

  return { achievements, earnedCount, totalCount, initialBadgesCompleted };
}
